// In-chat "Share this pack" card — pure helpers for the card that rides the reply of the turn that
// created `packs/<slug>/pack.md` (`metadata.packShareCard`). Named `-chat-card` to keep it apart from
// the pack screen's own sender/share card (components/symphony/packs/PackShareCard).
//
// Dependency-free, mirroring common-lib's `readPackShareCard`. Keep the two in step.

import { SHARE_ON_ARRIVAL_PARAM } from './share-on-arrival';

export type PackShareChatCardData = { slug: string; name: string };

/** Fail-closed on the slug (it becomes a path segment); a missing name falls back to the slug. */
export function readPackShareChatCard(metadata: unknown): PackShareChatCardData | undefined {
  const raw = (metadata as { packShareCard?: unknown } | null | undefined)?.packShareCard;
  if (!raw || typeof raw !== 'object') return undefined;
  const card = raw as Record<string, unknown>;
  const slug = typeof card.slug === 'string' ? card.slug.trim() : '';
  if (!slug || /[/\\?#\s]/.test(slug) || slug === '.' || slug === '..') return undefined;
  const name = typeof card.name === 'string' && card.name.trim() ? card.name.trim() : slug;
  return { slug, name };
}

/** Where the card's button goes: the pack's own screen, with its share flow started on arrival. */
export function packShareHref(slug: string): string {
  return `/packs/${encodeURIComponent(slug)}?${SHARE_ON_ARRIVAL_PARAM}=1`;
}
